module.exports = __webpack_public_path__ + "static/img/2017-04-08 13.54.38.a2481fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2017-04-08 13.54.38.jpg
// module id = NE9n
// module chunks = 4